import {
  ContentContainer,
  HeaderCellStyled,
  HeaderTextWithTooltipContainer,
  StyledText,
  StyledTooltip,
} from './HeaderCell.styles';
import React, { useState } from 'react';
import {
  StyledIcon,
  StyledIconInButton,
} from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';

interface Props {
  headerText?: string;
  isSortableColumn: boolean;
  columnName: string;
  width?: string;
  children?: React.ReactNode;
  onClick?: (columnName: string, direction: 'asc' | 'desc') => void;
  isSortedColumn?: boolean;
  sortDirection?: 'asc' | 'desc';
  borderRadius?: string;
  isScrollable?: boolean;
  infoTooltip?: string;
}

export const HeaderCell = (props: Props) => {
  const theme = useTheme();
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [root, setRoot] = useState<HTMLElement | null>(null);
  const shouldRenderTooltip =
    props.infoTooltip && tooltipVisible && root !== null;

  const handleColumnSort = (columnName: string) => {
    const newSortDirection = props.isSortedColumn
      ? props.sortDirection === 'asc'
        ? 'desc'
        : 'asc'
      : 'asc';
    props.onClick?.(columnName, newSortDirection);
  };
  return (
    <HeaderCellStyled
      data-testid={`column-header-${props.columnName.toLowerCase()}`}
      width={props.width}
      onClick={() => handleColumnSort(props.columnName)}
      isSortableColumn={props.isSortableColumn}
      borderRadius={props.borderRadius}
      isScrollable={props.isScrollable}
    >
      <ContentContainer
        isSortableColumn={props.isSortableColumn}
        data-testid={`sort-${props.columnName.toLowerCase()}`}
      >
        {props.headerText && !props.infoTooltip && (
          <StyledText title={props.headerText}>{props.headerText}</StyledText>
        )}
        {props.headerText && props.infoTooltip && (
          <HeaderTextWithTooltipContainer>
            <StyledText title={props.headerText}>{props.headerText}</StyledText>
            <StyledIcon
              size="20px"
              color={theme.atlas.semantic.color.type.default}
              className="uil uil-info-circle"
              ref={setRoot}
              onMouseOver={() => setTooltipVisible(true)}
              onMouseOut={() => setTooltipVisible(false)}
            />
          </HeaderTextWithTooltipContainer>
        )}
        {props.children}
        {props.isSortableColumn && (
          <StyledIconInButton
            size="medium"
            position="left"
            color={
              props.isSortedColumn
                ? theme.atlas.semantic.color.type.default
                : theme.atlas.semantic.color.action.primary.default
            }
            className={
              props.isSortedColumn && props.sortDirection === 'desc'
                ? 'uil uil-arrow-up'
                : 'uil uil-arrow-down'
            }
            style={{
              paddingLeft: '10px',
            }}
          />
        )}
      </ContentContainer>
      {shouldRenderTooltip && (
        <StyledTooltip
          text={props.infoTooltip}
          variant="up"
          root={root}
          width="300px"
        />
      )}
    </HeaderCellStyled>
  );
};
